<script setup lang="ts">
import { VColorsPicker, VSelectSearch } from '@/shared/ui'
import { useObjectSubTypeModel } from './../model/model.ts'

const model = useObjectSubTypeModel()

model.loadPayloads()

/**
 * Функция изменения зума по клику
 * @param direction
 */
const zoomChange = (direction: string) => {
  if (direction === 'up') {
    model.data.value.properties.zoom = model.data.value.properties.zoom + 1
  } else {
    model.data.value.properties.zoom = model.data.value.properties.zoom - 1
  }
}
</script>

<template>
  <div class="form__grid_3 mt-4">
    <VSelectSearch
      :label="$t('itf.object_type')"
      :items="model.payload.types"
      v-model="model.data.object_type_id"
      item-value="id"
      item-title="object_name"
      :disabled="model.data.id"
    />

    <VSelect
      :label="$t('itf.figure_to_map')"
      :items="model.payload.figures"
      v-model="model.data.figure_id"
      item-value="id"
      item-title="name"
    />

    <VColorsPicker :label="$t('itf.fill_color')" v-model="model.data.styles.fill" />
  </div>

  <div class="form__grid_3">
    <VColorsPicker :label="$t('itf.stroke_color')" v-model="model.data.styles.stroke.color" />

    <VTextField
      :label="$t('itf.stroke_width')"
      v-model="model.data.styles.stroke.width"
      type="number"
      :min="1"
      :max="50"
    />

    <VSelect
      :label="$t('itf.stroke_type')"
      :items="model.payload.lines"
      v-model="model.data.styles.stroke.line_id"
      item-value="id"
      item-title="name"
    />
  </div>

  <div class="form__grid_3">
    <div>
      <div class="text-center">
        {{ $t('itf.zoom_hide_object') }}
      </div>

      <VSlider
        :min="0"
        :max="22"
        :step="1"
        color="primary"
        thumb-label
        append-icon="add"
        prepend-icon="check_indeterminate_small"
        density="compact"
        @click:append="zoomChange('up')"
        @click:prepend="zoomChange('dawn')"
        v-model="model.data.properties.zoom"
      >
        <template #details>
          <div v-if="model.data.properties.zoom > 21" class="invent-object-types-fields__slider">
            {{ $t('itf.not_visible_to_cart') }}
          </div>
        </template>
      </VSlider>
    </div>
  </div>
</template>
